import { TmTableElementManagerError } from '@/core/error/table/tableManager/tmTableElementManagerError'

export class TmTableElementManagerServiceNotFoundError extends TmTableElementManagerError {
  public name = 'TmTableElementManagerServiceNotFoundError'
}
